import React from 'react';
import EmergencySpokePage from './EmergencySpokePage';

// Spoke: Akute Zahnschmerzen (auch nachts) — ohne Warnbox.
const EmergencyToothachePage: React.FC = () => (
  <EmergencySpokePage
    routeKey="emergency-toothache"
    namespace="toothache"
    medicalCondition="Toothache"
  />
);

export default EmergencyToothachePage;
